'use client'

import {
  Tabs,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@repo/ui'
import { useRouter } from 'next/navigation'

export const SettingsNavbar = ({
  navbarItems,
  pathname,
}: {
  navbarItems: Array<{ disabled?: boolean; path: string; title: string }>
  pathname: string
}) => {
  const router = useRouter()

  return (
    <nav className={'relative mx-auto flex w-full px-4 py-2'}>
      <div className={'absolute bottom-1.5 left-1 flex'}>
        <Tabs value={pathname}>
          <TabsList className="absolute bottom-2 border-none">
            {navbarItems.map(item =>
              item.disabled ? (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <TabsTrigger
                        asChild
                        className="cursor-pointer"
                        disabled={item.disabled}
                        key={item.title}
                        onClick={() => router.push(item.path)}
                        value={item.path}
                      >
                        <p>{item.title}</p>
                      </TabsTrigger>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Please fill company details</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : (
                <TabsTrigger
                  asChild
                  className="cursor-pointer"
                  key={item.title}
                  onClick={() => router.push(item.path)}
                  value={item.path}
                >
                  <p>{item.title}</p>
                </TabsTrigger>
              ),
            )}
          </TabsList>
        </Tabs>
      </div>
    </nav>
  )
}
